import React from 'react'
import { TyresWear, TYRE_SIDE, TyresType, SecondTyres } from '../components'
import FORM_FIELDS_TYPE from '../constants'

const formFields = {
  [FORM_FIELDS_TYPE.WEAR]: [
    {
      nodes: [
        props => <TyresWear.FormItem side={TYRE_SIDE.FRONT} {...props} />,
        props => <TyresWear.FormItem side={TYRE_SIDE.BACK} {...props} />
      ]
    }
  ],
  [FORM_FIELDS_TYPE.ADDITIONAL_INFORMATION]: [
    {
      nodes: [
        props => <TyresType.FormItem {...props} />,
        props => <SecondTyres.FormItem {...props} />
      ]
    }
  ],
  [FORM_FIELDS_TYPE.SECOND_WEAR]: [
    {
      nodes: [
        props => <TyresWear.FormItem side={TYRE_SIDE.FRONT} second {...props} />,
        props => <TyresWear.FormItem side={TYRE_SIDE.BACK} second {...props} />
      ]
    }
  ]
}

export default { formFields }
